import { render, staticRenderFns } from "./pgcQa.vue?vue&type=template&id=5db3edae&scoped=true"
import script from "./pgcQa.vue?vue&type=script&lang=js"
export * from "./pgcQa.vue?vue&type=script&lang=js"
import style0 from "./pgcQa.vue?vue&type=style&index=0&id=5db3edae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db3edae",
  null
  
)

export default component.exports